import { createReducer, on, Action } from '@ngrx/store';
import { State } from './state';
import * as ItemActions from './actions';
import { entityAdapter } from '../../../../root-store/adapter';
import { IItem } from '@app/models/item.model';
import { FilterSortList } from '@app/models/filter-sort.model';


const adapter = entityAdapter<IItem>();

const initialState = adapter.getInitialState({
  totalItems: 0,
  pageNum: 1,
  filterSortData: new FilterSortList(),
  checkedItems: [],
  selectedItem: null,
  projectId: 0,
  allowAddNewItem: true
});

const reducer = createReducer(
  initialState,
  on(ItemActions.GetItemsAction, (state) =>  {
      return {
        ...state,
        isLoading: true
      };
  }),
  on(ItemActions.PersistItemAction, (state: State, { payload }) => {

    const items = [...selectAll(state)];
    if (items.length >= 100) {
      items.pop();
    }
    return adapter.setAll([payload, ...items], {
      ...state,
      allowAddNewItem: false,
      totalItems: state.totalItems + 1
    });
  }),
  on(ItemActions.UpdateItemAction, (state: State, { payload }) => {
    const idToUpdate = payload.isNew ? '0' : payload.item._id;
    return adapter.updateOne(
      { id: idToUpdate, changes: payload.item },
      {
        ...state,
        allowAddNewItem: true,
      }
    );
  }),
  on(ItemActions.UpdateMassItemsAction, (state: State, { payload }) => {
    const changes = [{}, ...payload.updateFields].reduce((acc, field) => {
      acc[field.techName] = field.value;
      return acc;
    });
    const updates = payload.itemIds.map((itemId) => {
      const item = { ...state.entities[itemId], ...changes };
      return {
        id: itemId,
        changes: item,
      };
    });
    return adapter.updateMany(updates, state);
  }),
  on(ItemActions.PersistUpdateItemAction, (state: State, { payload }) => {
    return adapter.updateOne(
      { id: payload.item._id, changes: payload.item },
      state
    );
  }),
  on(ItemActions.BeginUpdateItemsAction, (state: State) => state),
  // on(ItemActions.PersistUpdateItemAction, state => state),
  on(ItemActions.SelectItemAction, (state: State, { payload }) => {
    return {
      ...state,
      selectedItem: payload,
    };
  }),
  on(ItemActions.CheckItemAction, (state: State, { payload }) => {
    return {
      ...state,
      checkedItems:
        state.checkedItems.indexOf(payload) > -1
          ? state.checkedItems
          : [...state.checkedItems, payload],
    };
  }),
  on(ItemActions.UncheckItemAction, (state: State, { payload }) => {
    return {
      ...state,
      checkedItems: state.checkedItems.filter((id) => id !== payload),
    };
  }),
  on(ItemActions.UncheckAllItemsAction, (state: State) => {
    return {
      ...state,
      checkedItems: [],
    };
  }),
  on(ItemActions.ChangePageAction, (state: State, { payload }) => {
    return {
      ...state,
      pageNum: payload,
    };
  }),
  on(ItemActions.ChangeFilterSortDataAction, (state: State, { payload }) => {
    return {
      ...state,
      filterSortData: { ...payload },
    };
  }),
  on(ItemActions.ChangeFilterAction, (state: State, { payload }) => {
    return {
      ...state,
      filterSortData: { ...state.filterSortData, filter: payload },
    };
  }),
  on(ItemActions.ChangeSortAction, (state: State, { payload }) => {
    return {
      ...state,
      filterSortData: { ...state.filterSortData, sort: payload },
    };
  }),
  on(ItemActions.GetTotalItemsAction, (state) => state),
  on(ItemActions.TotalItemsLoadedAction, (state: State, { payload }) => {
    return {
      ...state,
      totalItems: payload,
    };
  }),
  on(ItemActions.BeginCopyAndPasteItemsAction, (state: State) => state),
  on(ItemActions.BeginCutAndPasteItemsAction, (state: State) => state),
  on(ItemActions.BeginRemoveItemsAction, (state: State) => state),
  on(
    ItemActions.CopyAndPasteItemsActionFinished,
    (state: State, { payload }) => {
      return adapter.addMany(payload.items, {
        ...state,
        totalItems: state.totalItems + payload.items.length,
        checkedItems: [],
      });
      // items = items.slice(0, 100);
    }
  ),
  on(ItemActions.BeginDuplicateItemsAction, (state: State) => state),
  on(ItemActions.DuplicateItemsFinishedAction, (state: State, { payload }) => {
    return adapter.addMany(payload.items, {
      ...state,
      totalItems: state.totalItems + payload.items.length,
      checkedItems: [],
    });
    // items = items.slice(0, 100);
  }),
  on(ItemActions.BeginAddManyItemsAction, (state: State) => state),
  on(ItemActions.AddManyItemsFinishedAction, (state: State, { payload }) => {
    return adapter.addMany(payload.items, {
      ...state,
      totalItems: state.totalItems + payload.items.length,
      checkedItems: [],
    });
    // items = items.slice(0, 100);
  }),
  // on(ItemActions.RemoveItemsFinishedAction, (state: State, { payload }) => {
  //   const totalItems = state.totalItems - payload.itemIds.length;
  //   const totalPages = Math.ceil(state.totalItems / 100);
  //   const leftOnPage = state.items.filter((item) => payload.itemIds.indexOf(item._id) === -1);
  //   let newPage = state.pageNum;
  //   if (state.pageNum > 1 && state.pageNum === totalPages && leftOnPage.length === 0) {
  //     newPage = newPage - 1;
  //   }
  //   return {
  //     ...state,
  //     totalItems: totalItems,
  //     pageNum: newPage,
  //     checkedItems: []
  //   };
  // }),
  on(
    ItemActions.RefreshItemsAction,
    (state: State, { payload }) => {
        return {
          ...state,
          checkedItems: payload.resetCheckedItems ? [] : [ ...state.checkedItems ],
          isRefreshing: true
        };
    }
  ),
  on(ItemActions.ItemsLoadedAction, (state: State, { payload }) => {
    return adapter.setAll(payload,  {
      ...state,
      isRefreshing: false,
      isLoading: false,
      allowAddNewItem: true
    });
  }),
  on(ItemActions.BeginChangeOrderAction, (state: State) => state),
  on(ItemActions.UpdateProjectId, (state: State, { payload }) => {
    return {
      ...state,
      projectId: payload.projectId,
    };
  }),
  on(ItemActions.ProjectEnteredAction, (state: State, { payload }) => {
    return adapter.removeAll({...state,
      projectId: payload.projectId,
      pageNum: 1,
      filterSortData: new FilterSortList(),
      checkedItems: [],
    });
  }),
  on(ItemActions.BeginCalculateRulesForItemAction, (state: State) => state),
  on(ItemActions.BeginRecalculateRulesForFieldsAction, (state: State) => state),
  on(ItemActions.RecalculateRulesForFieldsFinishedAction, (state: State) => state),
  on(ItemActions.CalculateRulesForItemFinishedAction, (state: State) => state),
);

export function ItemReducer(state: State | undefined, action: Action) {
  return reducer(state, action);
}

export const { selectAll, selectEntities, selectIds, selectTotal } =
  adapter.getSelectors();
